// Ruta del panel de admin, sin escribirla en el código público.
//
// Antes era /admin, y el robots.txt la anunciaba ("Disallow: /admin"): es lo
// primero que prueban los escáneres. Ahora la ruta real vive solo en el
// servidor (functions/.env → ADMIN_PATH) y aquí guardamos su SHA-256 para
// reconocerla. El enlace del menú se pide al servidor, que solo lo da a
// cuentas con rol admin.
import { getIdToken } from '@/services/auth';

const HASH = (import.meta as any).env?.VITE_ADMIN_PATH_HASH as string | undefined;
const CACHE = 'funcomunion_admin_path';

async function sha256(texto: string): Promise<string> {
  const buf = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(texto));
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2, '0')).join('');
}

export async function esRutaAdmin(pathname: string): Promise<boolean> {
  const p = pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname;
  if (!HASH) return p === '/admin'; // desarrollo local sin .env
  try { return (await sha256(p)) === HASH; } catch { return false; }
}

/** Ruta del panel (p. ej. para el enlace del menú). Solo responde a admins. */
export async function obtenerRutaAdmin(): Promise<string | null> {
  try {
    const guardada = sessionStorage.getItem(CACHE);
    if (guardada) return guardada;
  } catch { /* */ }
  try {
    const token = await getIdToken();
    if (!token) return null;
    const r = await fetch('/api/admin/panel-path', { headers: { Authorization: `Bearer ${token}` } });
    if (!r.ok) return null;
    const { path } = await r.json();
    if (typeof path !== 'string' || !path.startsWith('/')) return null;
    try { sessionStorage.setItem(CACHE, path); } catch { /* */ }
    return path;
  } catch {
    return null;
  }
}
